import {lazy} from 'react';
import {Paths} from './Paths';
import {kycAdminRoutes} from './KYCAdminRoutes';
import {abAccountingRoutes} from './AbAccountingRoutes';

export const ADMIN = 'ADMIN';
export const ROLES = {ADMIN};

export const privateRoutes = {
	ADMIN: [
		// Dashboard for Crm
		{
			path: Paths.Crm,
			ComponentIn: lazy(() => import('Components/Crm/CrmDashboard/CrmIndex')),
		},

		// Crm orders

    {
      path: Paths.crmOrders + "/:type?",
      ComponentIn: lazy(() => import("Components/Crm/Orders/OrderSearch"))
    },
    {
      path: Paths.crmFailedOrders,
      ComponentIn: lazy(() => import("Components/Crm/Orders/FailedOrders"))
    },
    {
      path: Paths.crmFailedOrderView + "/:id",
      ComponentIn: lazy(() => import("Components/Crm/Orders/FailedOrderDetails"))
    },
    {
      path: Paths.crmBulkUndeliveredQueue,
      ComponentIn: lazy(() => import("Components/Crm/Orders/BulkUndeliveredQueue"))
    },
    {
      path: Paths.crmOrderReturn + "/:type?",
      ComponentIn: lazy(() => import("Components/Crm/Orders/OrderSearch"))
    },

		// Crm orders view
		{
			path: Paths.crmOrderView + '/:id',
			ComponentIn: lazy(() => import('Components/Crm/Orders/CrmOrders')),
		},

		// Crm orders view
		{
			path: Paths.crmOrderReturnView + '/:id',
			ComponentIn: lazy(() => import('Components/Crm/Orders/CrmOrderReturns')),
		},

    {
      path: Paths.users,
      ComponentIn: lazy(() => import("Components/Admin/Dashboard/index"))
    },
    {
      path: Paths.manageRole,
      ComponentIn: lazy(() => import("Components/Admin/ManageRole/manageRole"))
    },
    {
      path: Paths.manageUser,
      ComponentIn: lazy(() => import("Components/Admin/ManageUser/manageUser"))
    },
    {
      path: Paths.manageModules,
      ComponentIn: lazy(() => import("Components/Admin/ManageModules/manageModules"))
    },
    {
      path: Paths.editModule + "/:id",
      ComponentIn: lazy(() => import("Components/Admin/ManageModules/editModules"))
    },
    {
      path: Paths.bulkUploadPv,
      ComponentIn: lazy(() => import("Components/Admin/BulkUploadPv/BulkUploadPv"))
    },
    {
      path: Paths.ecomABLogin,
      ComponentIn: lazy(() => import("Components/Admin/EcomABLogin/EcomABLogin"))
    },
    {
      path: Paths.updatePrice,
      ComponentIn: lazy(() => import("Components/Admin/UpdatePrice/UpdatePrice"))
    },
    {
      path: Paths.updateProducts,
      ComponentIn: lazy(() => import("Components/Admin/UpdateProducts/UpdateProducts"))
    },
    {
      path: Paths.manageBatch,
      ComponentIn: lazy(() => import("Components/Admin/UdaanManager/manageBatch"))
    },
    {
      path: Paths.udaanReport,
      ComponentIn: lazy(
        () => import("Components/Admin/UdaanManager/RegistrationReport/ManageReport")
      )
    },
    {
      path: Paths.nirjaraDashboard,
      ComponentIn: lazy(() => import("Components/Admin/NirjaraDashboard/NirjaraDashboard"))
    },
    {
      path: Paths.nirjaraAdminReview + "/:id",
      ComponentIn: lazy(() => import("Components/Admin/NirjaraDashboard/NirjaraReviewDetails"))
    },
    //Reports in MDM
    {
      path: Paths.ulpQuick,
      ComponentIn: lazy(() => import("Components/Admin/UlpQuickManager/RegistrationList"))
    },
    {
      path: Paths.swasthyaShivir,
      ComponentIn: lazy(() => import("Components/Admin/SwasthyaShivir/RegistrationList"))
    },
    {
      path: Paths.grievanceList,
      ComponentIn: lazy(() => import("Components/Admin/GrievanceManager/GrievanceList"))
    },
    {
      path: Paths.ulpQuickRetentionReport,
      ComponentIn: lazy(
        () => import("Components/Admin/UlpQuickRetentionReport/UlpQuickRetentionReport")
      )
    },
    {
      path: Paths.batchAdd,
      ComponentIn: lazy(() => import("Components/Admin/UdaanManager/AddEditBatch"))
    },
    {
      path: Paths.batchEdit + "/:id",
      ComponentIn: lazy(() => import("Components/Admin/UdaanManager/AddEditBatch"))
    },
    {
      path: Paths.categoryList,
      ComponentIn: lazy(() => import("Components/Admin/Category/CategoryList"))
    },
    {
      path: Paths.categoryAdd,
      ComponentIn: lazy(() => import("Components/Admin/Category/CategoryAdd"))
    },
    {
      path: Paths.categoryEdit + "/:id",
      ComponentIn: lazy(() => import("Components/Admin/Category/CategoryEdit"))
    },
    {
      path: Paths.categoryEdit,
      ComponentIn: lazy(() => import("Components/Admin/Category/CategoryEdit"))
    },
    {
      path: Paths.addRole,
      ComponentIn: lazy(() => import("Components/Admin/ManageRole/AddEditManageRole"))
    },
    {
      path: Paths.editRole + "/:id",
      ComponentIn: lazy(() => import("Components/Admin/ManageRole/AddEditManageRole"))
    },
    {
      path: Paths.tagsList,
      ComponentIn: lazy(() => import("Components/Admin/Tags/TagList"))
    },
    {
      path: Paths.addTag,
      ComponentIn: lazy(() => import("Components/Admin/Tags/AddTag"))
    },
    {
      path: Paths.editTag + "/:id",
      ComponentIn: lazy(() => import("Components/Admin/Tags/EditTag"))
    },
    {
      path: Paths.addUser,
      ComponentIn: lazy(() => import("Components/Admin/ManageUser/AddUser"))
    },
    {
      path: Paths.editUser + "/:id",
      ComponentIn: lazy(() => import("Components/Admin/ManageUser/EditUser"))
    },
    {
      path: Paths.brandList,
      ComponentIn: lazy(() => import("Components/Admin/Brands/BrandsList"))
    },

		{
			path: Paths.brandTemplateList,
			ComponentIn: lazy(() => import('Components/Admin/Brand_Template/List')),
		},

		{
			path: Paths.brandTemplateAdd,
			ComponentIn: lazy(() => import('Components/Admin/Brand_Template/KeySoulTemplate')),
		},
		{
			path: Paths.brandTemplateEdit + '/:id',
			ComponentIn: lazy(() => import('Components/Admin/Brand_Template/KeySoulTemplateEdit')),
		},

		{
			path: Paths.brandAdd,
			ComponentIn: lazy(() => import('Components/Admin/Brands/BrandsAdd')),
		},
		{
			path: Paths.brandEdit + '/:id',
			ComponentIn: lazy(() => import('Components/Admin/Brands/BrandsEdit')),
		},
		{
			path: Paths.attributesList,
			ComponentIn: lazy(() => import('Components/Admin/Attributes/AttributesList')),
		},
		{
			path: Paths.attributesAdd,
			ComponentIn: lazy(() => import('Components/Admin/Attributes/AttributesAdd')),
		},
		{
			path: Paths.attributesEdit + '/:id',
			ComponentIn: lazy(() => import('Components/Admin/Attributes/AttributesEdit')),
		},
		{
			path: Paths.variantsList,
			ComponentIn: lazy(() => import('Components/Admin/Variants/VariantsList')),
		},
		{
			path: Paths.variantsAdd,
			ComponentIn: lazy(() => import('Components/Admin/Variants/VariantsAdd')),
		},
		{
			path: Paths.variantsEdit + '/:id',
			ComponentIn: lazy(() => import('Components/Admin/Variants/VariantsEdit')),
		},
		{
			path: Paths.productList,
			ComponentIn: lazy(() => import('Components/Admin/Products/ProductList')),
		},
		{
			path: Paths.productAdd,
			ComponentIn: lazy(() => import('Components/Admin/Products/ProductAdd')),
		},
		{
			path: Paths.productEdit + '/:id',
			ComponentIn: lazy(() => import('Components/Admin/Products/ProductEdit')),
		},
		{
			path: Paths.walletList,
			ComponentIn: lazy(() => import('Components/Admin/Wallets/AllWallet/WalletsList')),
		},
		{
			path: Paths.walletAdd,
			ComponentIn: lazy(() => import('Components/Admin/Wallets/AllWallet/WalletsAddEdit')),
		},
		{
			path: Paths.walletEdit + '/:id',
			ComponentIn: lazy(() => import('Components/Admin/Wallets/AllWallet/WalletsAddEdit')),
		},
		{
			path: Paths.mappedList,
			ComponentIn: lazy(() => import('Components/Admin/Wallets/MappedWallet/MappedList')),
		},
		{
			path: Paths.mappedAdd,
			ComponentIn: lazy(() => import('Components/Admin/Wallets/MappedWallet/MappedAdd')),
		},
		{
			path: Paths.mappedTdsAdd,
			ComponentIn: lazy(() => import('Components/Admin/Wallets/MappedWallet/MappedTdsAdd')),
		},
		{
			path: Paths.mappedBulkUpload,
			ComponentIn: lazy(() => import('Components/Admin/Wallets/MappedWallet/MappedBulkUpload')),
		},
		{
			path: Paths.mappedEdit + '/:id',
			ComponentIn: lazy(() => import('Components/Admin/Wallets/MappedWallet/MappedEdit')),
		},
		{
			path: Paths.walletRemainingBalance,
			ComponentIn: lazy(() => import('Components/Admin/Wallets/WalletRemainingBalance/WalletRemainingBalance')),
		},
		{
			path: Paths.consistencyData,
			ComponentIn: lazy(() => import('Components/Admin/Finance/ConsistencyDashboardBusiness')),
		},
		{
			path: Paths.cashBonusData,
			ComponentIn: lazy(() => import('Components/Admin/Finance/CashBonusData')),
		},
		{
			path: Paths.finalCashBonus,
			ComponentIn: lazy(() => import('Components/Admin/Finance/FinalCashBonus')),
		},
		{
			path: Paths.finalRcmConsistency,
			ComponentIn: lazy(() => import('Components/Admin/Finance/FinalRcmConsistency')),
		},
		{
			path: Paths.couponList,
			ComponentIn: lazy(() => import('Components/Admin/Coupon/CouponList')),
		},
		{
			path: Paths.couponAdd,
			ComponentIn: lazy(() => import('Components/Admin/Coupon/CouponAdd')),
		},
		{
			path: Paths.couponEdit + '/:id',
			ComponentIn: lazy(() => import('Components/Admin/Coupon/CouponEdit')),
		},

		{
			path: Paths.offersList,
			ComponentIn: lazy(() => import('Components/Admin/Offers/OffersList')),
		},
		{
			path: Paths.offersAdd,
			ComponentIn: lazy(() => import('Components/Admin/Offers/OffersAdd')),
		},
		{
			path: Paths.offersEdit + '/:id',
			ComponentIn: lazy(() => import('Components/Admin/Offers/OffersAdd')),
		},
		{
			path: Paths.shippingSequencesList,
			ComponentIn: lazy(() => import('Components/Admin/CustomShippingOrder/CSO/CSOList')),
		},
		{
			path: Paths.shippingSequencesAdd,
			ComponentIn: lazy(() => import('Components/Admin/CustomShippingOrder/CSO/AddCSO')),
		},
		{
			path: Paths.shippingSequencesEdit + '/:id',
			ComponentIn: lazy(() => import('Components/Admin/CustomShippingOrder/CSO/EditCSO')),
		},

		{
			path: Paths.pincodeMappingList,
			ComponentIn: lazy(() => import('Components/Admin/PincodeMapping/PincodeMappingList')),
		},
		{
			path: Paths.pincodeScheduleList,
			ComponentIn: lazy(() => import('Components/Admin/PincodeMapSchedule/ScheduleList')),
		},
		{
			path: Paths.pincodeScheduleAdd,
			ComponentIn: lazy(() => import('Components/Admin/PincodeMapSchedule/AddEditSchedule')),
		},
		{
			path: Paths.pincodeScheduleEdit + '/:id',
			ComponentIn: lazy(() => import('Components/Admin/PincodeMapSchedule/AddEditSchedule')),
		},
		{
			path: Paths.pincodeListing,
			ComponentIn: lazy(() => import('Components/Admin/PincodeListing/PincodeListingIndex')),
		},
		{
			path: Paths.pincodeMappingAdd,
			ComponentIn: lazy(() => import('Components/Admin/PincodeMapping/PincodeMappingAdd')),
		},
		{
			path: Paths.pincodeMappingEdit + '/:id',
			ComponentIn: lazy(() => import('Components/Admin/PincodeMapping/PincodeMappingEdit')),
		},

		{
			path: Paths.sequenceMapppingList,
			ComponentIn: lazy(() => import('Components/Admin/CustomShippingOrder/CSOMap/CSOMapList')),
		},
		{
			path: Paths.sequenceMapppingAdd,
			ComponentIn: lazy(() => import('Components/Admin/CustomShippingOrder/CSOMap/AddCSOMap')),
		},
		{
			path: Paths.sequenceMapppingEdit + '/:id',
			ComponentIn: lazy(() => import('Components/Admin/CustomShippingOrder/CSOMap/EditCSOMap')),
		},
		{
			path: Paths.shippingChargesList,
			ComponentIn: lazy(() => import('Components/Admin/ManageShippingCharges/ShippingChargesList')),
		},
		{
			path: Paths.shippingChargesAdd,
			ComponentIn: lazy(() => import('Components/Admin/ManageShippingCharges/AddEditShippingCharges')),
		},
		{
			path: Paths.downloadList,
			ComponentIn: lazy(() => import('Components/Admin/Download/DownloadContent/DownloadList')),
		},
		{
			path: Paths.downloadAdd,
			ComponentIn: lazy(() => import('Components/Admin/Download/DownloadContent/DownloadAddEdit')),
		},
		{
			path: Paths.downloadEdit + '/:id',
			ComponentIn: lazy(() => import('Components/Admin/Download/DownloadContent/DownloadAddEdit')),
		},
		{
			path: Paths.shippingChargesEdit + '/:id',
			ComponentIn: lazy(() => import('Components/Admin/ManageShippingCharges/AddEditShippingCharges')),
		},
		{
			path: Paths.cacheManager,
			ComponentIn: lazy(() => import('Components/Admin/Configurations/CacheManager/CacheManager')),
		},
		{
			path: Paths.bannerList,
			ComponentIn: lazy(() => import('Components/Admin/Configurations/BannerManagement/BannerList')),
		},
		{
			path: Paths.bannerAdd,
			ComponentIn: lazy(() => import('Components/Admin/Configurations/BannerManagement/AddEditBanner')),
		},
		{
			path: Paths.bannerEdit + '/:id',
			ComponentIn: lazy(() => import('Components/Admin/Configurations/BannerManagement/AddEditBanner')),
		},
		{
			path: Paths.settingsList,
			ComponentIn: lazy(() => import('Components/Admin/Configurations/Settings/SettingsList')),
		},
		{
			path: Paths.mdmSettingsList,
			ComponentIn: lazy(() => import('Components/Admin/MdmConfigurations/MdmSettings/MdmSettingList')),
		},

		{
			path: Paths.notificationCategoryAdd,
			ComponentIn: lazy(
				() => import('Components/Admin/ManageNotification/NotificationCategory/AddNotificationCategory')
			),
		},
		{
			path: Paths.notificationCategoryEdit + '/:id',
			ComponentIn: lazy(
				() => import('Components/Admin/ManageNotification/NotificationCategory/EditNotificationCategory')
			),
		},
		{
			path: Paths.notificationCategoryList,
			ComponentIn: lazy(
				() => import('Components/Admin/ManageNotification/NotificationCategory/NotificationCategoryList')
			),
		},

		{
			path: Paths.notificationAdd,
			ComponentIn: lazy(() => import('Components/Admin/ManageNotification/Notification/AddNotification')),
		},
		{
			path: Paths.notificationEdit + '/:id',
			ComponentIn: lazy(() => import('Components/Admin/ManageNotification/Notification/EditNotification')),
		},
		{
			path: Paths.notificationList,
			ComponentIn: lazy(() => import('Components/Admin/ManageNotification/Notification/NotificationList')),
		},
		{
			path: Paths.sendNotificationAdd,
			ComponentIn: lazy(() => import('Components/Admin/ManageNotification/SendNotification/AddSendNotification')),
		},
		{
			path: Paths.sendNotificationView + '/:id',
			ComponentIn: lazy(
				() => import('Components/Admin/ManageNotification/SendNotification/ViewSendNotification')
			),
		},
		{
			path: Paths.abScheduledMessagesList,
			ComponentIn: lazy(() => import('Components/Admin/AbScheduledMessages/AbScheduledMessagesList')),
		},
		{
			path: Paths.abScheduledMessagesAdd,
			ComponentIn: lazy(() => import('Components/Admin/AbScheduledMessages/AbScheduledMessagesAddEdit')),
		},
		{
			path: Paths.abScheduledMessagesEdit + '/:id',
			ComponentIn: lazy(() => import('Components/Admin/AbScheduledMessages/AbScheduledMessagesAddEdit')),
		},
		{
			path: Paths.sendNotificationList,
			ComponentIn: lazy(
				() => import('Components/Admin/ManageNotification/SendNotification/SendNotificationList')
			),
		},
		// Targeted Notifications
		{
			path: Paths.targetedNotificationList,
			ComponentIn: lazy(
				() => import('Components/Admin/ManageNotification/TargetedNotification/TargetedNotificationList')
			),
		},
		// Notification Templates
		{
			path: Paths.notificationTemplateList,
			ComponentIn: lazy(
				() => import('Components/Admin/ManageNotification/NotificationTemplates/NotificationTemplateList')
			),
		},
		{
			path: Paths.notificationTemplateAdd,
			ComponentIn: lazy(
				() => import('Components/Admin/ManageNotification/NotificationTemplates/AddNotificationTemplate')
			),
		},
		{
			path: Paths.notificationTemplateEdit + '/:id',
			ComponentIn: lazy(
				() => import('Components/Admin/ManageNotification/NotificationTemplates/AddNotificationTemplate')
			),
		},
		{
			path: Paths.targetedNotificationAdd,
			ComponentIn: lazy(
				() => import('Components/Admin/ManageNotification/TargetedNotification/AddTargetedNotification')
			),
		},
		{
			path: Paths.targetedNotificationView + '/:id',
			ComponentIn: lazy(
				() => import('Components/Admin/ManageNotification/TargetedNotification/ViewTargetedNotification')
			),
		},
		// Targeted Voice Broadcast
		{
			path: Paths.voiceBroadcastList,
			ComponentIn: lazy(() => import('Components/Admin/TargetedVoiceBroadcast/TargetedVoiceBroadcastList')),
		},
		{
			path: Paths.voiceBroadcastAdd,
			ComponentIn: lazy(() => import('Components/Admin/TargetedVoiceBroadcast/TargetedVoiceBroadcastForm')),
		},
		{
			path: Paths.voiceBroadcastView + '/:id',
			ComponentIn: lazy(() => import('Components/Admin/TargetedVoiceBroadcast/TargetedVoiceBroadcastView')),
		},
		{
			path: Paths.voiceBroadcastReport + '/:id',
			ComponentIn: lazy(() => import('Components/Admin/TargetedVoiceBroadcast/TargetedVoiceBroadcastReport')),
		},
		{
			path: Paths.remarksMaster,
			ComponentIn: lazy(() => import('Components/Admin/RemarksMaster/RemarksMasterList')),
		},
		{
			path: Paths.remarkModulesMaster,
			ComponentIn: lazy(() => import('Components/Admin/RemarkModulesMaster/RemarkModulesMasterList')),
		},
		{
			path: Paths.grandGrowthAwardLeaders,
			ComponentIn: lazy(() => import('Components/Admin/GrandGrowthAward/LeadersManager')),
		},
		{
			path: Paths.grandGrowthAwardReports,
			ComponentIn: lazy(() => import('Components/Admin/GrandGrowthAward/ReportsManager')),
		},
		{
			path: Paths.grandGrowthAwardReportAssign,
			ComponentIn: lazy(() => import('Components/Admin/GrandGrowthAward/AssignReports')),
		},
		{
			path: Paths.grandGrowthAwardEligibility,
			ComponentIn: lazy(() => import('Components/Admin/GrandGrowthAward/EligibilityManager')),
		},
		{
			path: Paths.grandGrowthAwardLevel1Check,
			ComponentIn: lazy(() => import('Components/Admin/GrandGrowthAward/Level1Check')),
		},
		{
			path: Paths.grandGrowthAwardLevel2Check,
			ComponentIn: lazy(() => import('Components/Admin/GrandGrowthAward/Level2Check')),
		},
		{
			path: Paths.grandGrowthAwardFinalExport,
			ComponentIn: lazy(() => import('Components/Admin/GrandGrowthAward/FinalExport')),
		},
		{
			path: Paths.productSectionsList,
			ComponentIn: lazy(() => import('Components/Admin/ProductSections/ProdcutSectionsList')),
		},
		{
			path: Paths.productsSectionsAdd,
			ComponentIn: lazy(() => import('Components/Admin/ProductSections/AddEditProductsSection')),
		},
		{
			path: Paths.productsSectionsEdit + '/:id',
			ComponentIn: lazy(() => import('Components/Admin/ProductSections/AddEditProductsSection')),
		},
		{
			path: Paths.manageMenuList,
			ComponentIn: lazy(() => import('Components/Admin/MenuManagement/MenuMangementList')),
		},
		{
			path: Paths.manageMenuListAdd,
			ComponentIn: lazy(() => import('Components/Admin/MenuManagement/AddEditMegaMenu')),
		},
		{
			path: Paths.manageMenuListEdit + '/:id',
			ComponentIn: lazy(() => import('Components/Admin/MenuManagement/AddEditMegaMenu')),
		},

		// Profile Menu Management
		{
			path: Paths.manageProfileMenuList,
			ComponentIn: lazy(() => import('Components/Admin/ProfileMenuManagement/ProfileMenuManagementList')),
		},
		{
			path: Paths.manageProfileMenuListAdd,
			ComponentIn: lazy(() => import('Components/Admin/ProfileMenuManagement/AddEditProfileMenu')),
		},
		{
			path: Paths.manageProfileMenuListEdit + '/:id',
			ComponentIn: lazy(() => import('Components/Admin/ProfileMenuManagement/AddEditProfileMenu')),
		},

		{
			path: Paths.featuredCategory,
			ComponentIn: lazy(() => import('Components/Admin/FeaturedCategory/FeaturedCategory')),
		},
		{
			path: Paths.featuredCategoryDetails + '/:id',
			ComponentIn: lazy(() => import('Components/Admin/FeaturedCategory/CategoryDetails')),
		},
		{
			path: Paths.mediaCategory,
			ComponentIn: lazy(() => import('Components/Admin/ManageMedia/MediaCategories/MediaCategoryList')),
		},
		{
			path: Paths.mediaCategoryAdd,
			ComponentIn: lazy(() => import('Components/Admin/ManageMedia/MediaCategories/AddEditMediaCategory')),
		},
		{
			path: Paths.mediaCategoryEdit + '/:id',
			ComponentIn: lazy(() => import('Components/Admin/ManageMedia/MediaCategories/AddEditMediaCategory')),
		},
		{
			path: Paths.mediaContentList,
			ComponentIn: lazy(() => import('Components/Admin/ManageMedia/MediaContent/MediaContentList')),
		},
		{
			path: Paths.mediaContentAdd,
			ComponentIn: lazy(() => import('Components/Admin/ManageMedia/MediaContent/AddEditMediaContent')),
		},
		{
			path: Paths.mediaContentEdit + '/:id',
			ComponentIn: lazy(() => import('Components/Admin/ManageMedia/MediaContent/AddEditMediaContent')),
		},
		{
			path: Paths.abMessageList,
			ComponentIn: lazy(() => import('Components/Admin/ABMessages/ABMessageList')),
		},
		{
			path: Paths.abMessageListAdd,
			ComponentIn: lazy(() => import('Components/Admin/ABMessages/ABMessageAddEdit')),
		},
		{
			path: Paths.abMessageListEdit + '/:id',
			ComponentIn: lazy(() => import('Components/Admin/ABMessages/ABMessageAddEdit')),
		},
		{
			path: Paths.pincodeAreaMappingList,
			ComponentIn: lazy(() => import('Components/Admin/PincodeAreaMapping/PincodeAreaMappingList')),
		},
		{
			path: Paths.pincodeAreaMappingAdd,
			ComponentIn: lazy(() => import('Components/Admin/PincodeAreaMapping/AddEditPincodeAreaMapping')),
		},
		{
			path: Paths.pincodeAreaMappingEdit + '/:id',
			ComponentIn: lazy(() => import('Components/Admin/PincodeAreaMapping/AddEditPincodeAreaMapping')),
		},

		{
			path: Paths.downloadCategoryList,
			ComponentIn: lazy(() => import('Components/Admin/Download/DownloadCategory/DownloadCategoryList')),
		},
		{
			path: Paths.downloadCategoryAdd,
			ComponentIn: lazy(() => import('Components/Admin/Download/DownloadCategory/AddEditDownloadCategory')),
		},
		{
			path: Paths.downloadCategoryEdit + '/:id',
			ComponentIn: lazy(() => import('Components/Admin/Download/DownloadCategory/AddEditDownloadCategory')),
		},

		{
			path: Paths.downloadLanguageList,
			ComponentIn: lazy(() => import('Components/Admin/Download/DownloadLanguage/DownloadLanguageList')),
		},
		{
			path: Paths.downloadLanguageAdd,
			ComponentIn: lazy(() => import('Components/Admin/Download/DownloadLanguage/AddEditDownloadLanguage')),
		},
		{
			path: Paths.downloadLanguageEdit + '/:id',
			ComponentIn: lazy(() => import('Components/Admin/Download/DownloadLanguage/AddEditDownloadLanguage')),
		},

		{
			path: Paths.contentTypeList,
			ComponentIn: lazy(() => import('Components/Admin/Download/ContentType/ContentTypeList')),
		},
		{
			path: Paths.contentTypeAdd,
			ComponentIn: lazy(() => import('Components/Admin/Download/ContentType/AddEditContentType')),
		},
		{
			path: Paths.contentTypeEdit + '/:id',
			ComponentIn: lazy(() => import('Components/Admin/Download/ContentType/AddEditContentType')),
		},

		{
			path: Paths.voucherList,
			ComponentIn: lazy(() => import('Components/Admin/Vouchers/VoucherList')),
		},
		{
			path: Paths.voucherAdd,
			ComponentIn: lazy(() => import('Components/Admin/Vouchers/AddEditVoucher')),
		},
		{
			path: Paths.voucherEdit + '/:id',
			ComponentIn: lazy(() => import('Components/Admin/Vouchers/AddEditVoucher')),
		},

		{
			path: Paths.purchaseRulesList,
			ComponentIn: lazy(() => import('Components/Admin/PurchaseRules/PurchaseRulesList')),
		},

		{
			path: Paths.eventsList,
			ComponentIn: lazy(() => import('Components/Admin/RCMEvents/EventsList')),
		},
		{
			path: Paths.ulpTarget,
			ComponentIn: lazy(() => import('Components/Admin/ULPTarget/ULPTarget')),
		},
		{
			path: Paths.eventsAdd,
			ComponentIn: lazy(() => import('Components/Admin/RCMEvents/AddEditEvents')),
		},
		{
			path: Paths.eventsEdit + '/:id',
			ComponentIn: lazy(() => import('Components/Admin/RCMEvents/AddEditEvents')),
		},

		{
			path: Paths.meetingsList,
			ComponentIn: lazy(() => import('Components/Admin/MeetingsSchedule/MeetingsScheduleList')),
		},
		{
			path: Paths.meetingsAdd,
			ComponentIn: lazy(() => import('Components/Admin/MeetingsSchedule/AddEditMeeting')),
		},
		{
			path: Paths.meetingsEdit + '/:id',
			ComponentIn: lazy(() => import('Components/Admin/MeetingsSchedule/AddEditMeeting')),
		},
		{
			path: Paths.offerImpactReport,
			ComponentIn: lazy(() => import('Components/Admin/OfferImpactReport/OfferPromotionImpact')),
		},

		{
			path: Paths.marketingPlanLanguageList,
			ComponentIn: lazy(
				() => import('Components/Admin/MarketingPlan/MarketingPlanLanguage/MarketingPlanLanguagesList')
			),
		},
		{
			path: Paths.marketingPlanLanguageAdd,
			ComponentIn: lazy(
				() => import('Components/Admin/MarketingPlan/MarketingPlanLanguage/AddEditMarketingPlanLanguage')
			),
		},
		{
			path: Paths.marketingPlanLanguageEdit + '/:id',
			ComponentIn: lazy(
				() => import('Components/Admin/MarketingPlan/MarketingPlanLanguage/AddEditMarketingPlanLanguage')
			),
		},

		{
			path: Paths.marketingPlanList,
			ComponentIn: lazy(() => import('Components/Admin/MarketingPlan/MarketingPlan/MarketingPlansList')),
		},
		{
			path: Paths.marketingPlanAdd,
			ComponentIn: lazy(() => import('Components/Admin/MarketingPlan/MarketingPlan/AddEditMarketingPlan')),
		},
		{
			path: Paths.marketingPlanEdit + '/:id',
			ComponentIn: lazy(() => import('Components/Admin/MarketingPlan/MarketingPlan/AddEditMarketingPlan')),
		},

		{
			path: Paths.sizeChartList,
			ComponentIn: lazy(() => import('Components/Admin/SizeCharts/SizeChartsList')),
		},
		{
			path: Paths.ecomSettings,
			ComponentIn: lazy(() => import('Components/Admin/ecomSettings/ecomSettingsList')),
		},
		{
			path: Paths.sizeChartAdd,
			ComponentIn: lazy(() => import('Components/Admin/SizeCharts/AddEditSizeChart')),
		},
		{
			path: Paths.sizeChartEdit + '/:id',
			ComponentIn: lazy(() => import('Components/Admin/SizeCharts/AddEditSizeChart')),
		},
		{
			path: Paths.generalPagesList,
			ComponentIn: lazy(() => import('Components/Admin/GeneralPages/GeneralPageList')),
		},
		{
			path: Paths.ecomContactList,
			ComponentIn: lazy(() => import('Components/Admin/ecomSettings/ecomSettingsList')),
		},
		{
			path: Paths.generalPagesAdd,
			ComponentIn: lazy(() => import('Components/Admin/GeneralPages/AddEditGeneralPage')),
		},
		{
			path: Paths.generalPagesEdit + '/:id',
			ComponentIn: lazy(() => import('Components/Admin/GeneralPages/AddEditGeneralPage')),
		},

		{
			path: Paths.aboutUsHistoryList,
			ComponentIn: lazy(() => import('Components/Admin/AboutUsHistory/AboutUsHistoryList')),
		},
		{
			path: Paths.aboutUsHistoryAdd,
			ComponentIn: lazy(() => import('Components/Admin/AboutUsHistory/AddEditAboutUsHistory')),
		},
		{
			path: Paths.aboutUsHistoryEdit + '/:id',
			ComponentIn: lazy(() => import('Components/Admin/AboutUsHistory/AddEditAboutUsHistory')),
		},
		{
			path: Paths.noticesList,
			ComponentIn: lazy(() => import('Components/Admin/Notices/NoticesList')),
		},
		{
			path: Paths.noticeAdd,
			ComponentIn: lazy(() => import('Components/Admin/Notices/AddEdditNotice')),
		},
		{
			path: Paths.noticeEdit + '/:id',
			ComponentIn: lazy(() => import('Components/Admin/Notices/AddEdditNotice')),
		},
		{
			path: Paths.complianceDocumentsList,
			ComponentIn: lazy(() => import('Components/Admin/ComplianceDocuments/ComplianceDocumentsList')),
		},
		{
			path: Paths.complianceDocumentsAdd,
			ComponentIn: lazy(() => import('Components/Admin/ComplianceDocuments/ComplianceDocumentsAddEdit')),
		},
		{
			path: Paths.complianceDocumentsEdit + '/:id',
			ComponentIn: lazy(() => import('Components/Admin/ComplianceDocuments/ComplianceDocumentsAddEdit')),
		},
		{
			path: Paths.faqsList,
			ComponentIn: lazy(() => import('Components/Admin/Faqs/FaqsList')),
		},
		{
			path: Paths.faqsAdd,
			ComponentIn: lazy(() => import('Components/Admin/Faqs/FaqsAddEdit')),
		},
		{
			path: Paths.faqsEdit + '/:id',
			ComponentIn: lazy(() => import('Components/Admin/Faqs/FaqsAddEdit')),
		},

		//Manage banks
		{
			path: Paths.bankList,
			ComponentIn: lazy(() => import('Components/Admin/ManageBanks/BankList')),
		},
		{
			path: Paths.bankAdd,
			ComponentIn: lazy(() => import('Components/Admin/ManageBanks/BankAddEdit')),
		},
		{
			path: Paths.bankEdit + '/:id',
			ComponentIn: lazy(() => import('Components/Admin/ManageBanks/BankAddEdit')),
		},
		//Manage branches
		{
			path: Paths.branchList,
			ComponentIn: lazy(() => import('Components/Admin/ManageBranches/BranchList')),
		},
		{
			path: Paths.branchAdd,
			ComponentIn: lazy(() => import('Components/Admin/ManageBranches/BranchAddEdit')),
		},
		{
			path: Paths.branchEdit + '/:id',
			ComponentIn: lazy(() => import('Components/Admin/ManageBranches/BranchAddEdit')),
		},
		//employee
		{
			path: Paths.employeeList,
			ComponentIn: lazy(() => import('Components/Admin/Employee/EmployeeList')),
		},
		{
			path: Paths.employeeAdd,
			ComponentIn: lazy(() => import('Components/Admin/Employee/EmployeeAddEdit')),
		},
		{
			path: Paths.employeeEdit + '/:id',
			ComponentIn: lazy(() => import('Components/Admin/Employee/EmployeeAddEdit')),
		},
		{
			path: Paths.executivesList,
			ComponentIn: lazy(() => import('Components/Admin/ManageExecutives/ExecutivesList')),
		},
		{
			path: Paths.executiveAdd,
			ComponentIn: lazy(() => import('Components/Admin/ManageExecutives/AddEditExecutives')),
		},
		{
			path: Paths.executiveEdit + '/:id',
			ComponentIn: lazy(() => import('Components/Admin/ManageExecutives/AddEditExecutives')),
		},
		...kycAdminRoutes,
		...abAccountingRoutes,
		{
			path: Paths.ecomUserPermissionList,
			ComponentIn: lazy(
				() => import('Components/Admin/ManageEcomUser/manageUserPermission/EcomUserPermissionList')
			),
		},
		{
			path: Paths.ecomUserPermissionEdit + '/:id',
			ComponentIn: lazy(
				() => import('Components/Admin/ManageEcomUser/manageUserPermission/EcomUserPermissionEdit')
			),
		},
		{
			path: Paths.Aparajita,
			ComponentIn: lazy(() => import('Components/Admin/Aparajita/AparajitaModule')),
		},
		{
			path: Paths.purchaserInYourGroup,
			ComponentIn: lazy(() => import('Components/Admin/PurchaserInYourGroup/PurchaserInYourGroupModule')),
		},
		{
			path: Paths.RupantaranYatraDelhi,
			ComponentIn: lazy(() => import('Components/Admin/RupantaranYatraDelhi/RupantaranYatraDelhiModule')),
		},
		{
			path: Paths.specialWomenRegistration,
			ComponentIn: lazy(() => import('Components/Admin/SpecialWomenRegistration/SpecialWomenRegistrationList')),
		},
		{
			path: Paths.RCMDisplayWallReport,
			ComponentIn: lazy(() => import('Components/Admin/DisplayWallReport/DisplayWallReportModule')),
		},
		{
			path: Paths.PUCReport,
			ComponentIn: lazy(() => import('Components/Admin/PUCReport/PUCReportModule')),
		},
		{
			path: Paths.ABKycStatus,
			ComponentIn: lazy(() => import('Components/Admin/ABKycStatus')),
		},
		{
			path: Paths.UserDetails,
			ComponentIn: lazy(() => import('Components/Admin/CallCenterReports/UserDetails/userDetailsIndex')),
		},
		{
			path: Paths.Plantations,
			ComponentIn: lazy(() => import('Components/Admin/CallCenterReports/Plantations/PlantationsIndex')),
		},
		{
			path: Paths.BloodDonors,
			ComponentIn: lazy(() => import('Components/Admin/CallCenterReports/BloodDonors/BloodDonorsIndex')),
		},

		{
			path: Paths.ConsistencyDashboard,
			ComponentIn: lazy(
				() => import('Components/Admin/CallCenterReports/ConsistencyDashboard/ConsistencyDashboardIndex')
			),
		},
		// Depots Routes
		{
			path: Paths.depotList,
			ComponentIn: lazy(() => import('Components/Admin/Depots/DepotList')),
		},
		{
			path: Paths.depotAdd,
			ComponentIn: lazy(() => import('Components/Admin/Depots/DepotAdd')),
		},
		{
			path: Paths.depotEdit + '/:id',
			ComponentIn: lazy(() => import('Components/Admin/Depots/DepotEdit')),
		},

		// Miscellaneous Routes
		{
			path: Paths.registeredBuyer,
			ComponentIn: lazy(() => import('Components/KycAdmin/Miscellaneous/RegisteredBuyer/RegisteredBuyer')),
		},
		{
			path: Paths.normalBuyer,
			ComponentIn: lazy(() => import('Components/KycAdmin/Miscellaneous/NormalBuyer/NormalBuyer')),
		},
		{
			path: Paths.duplicateRecord,
			ComponentIn: lazy(() => import('Components/KycAdmin/Miscellaneous/DuplicateRecords/DuplicateRecords')),
		},
		{
			path: Paths.abSponsorAllowMisuse,
			ComponentIn: lazy(
				() => import('Components/KycAdmin/Miscellaneous/AbSponsorAllowMisuse/AbSponsorAllowMisuse')
			),
		},

		// kyc history Paths
		{
			path: Paths.mobileHistory,
			ComponentIn: lazy(() => import('Components/KycAdmin/KycHistory/MobileHistory/MobileHistory')),
		},
		{
			path: Paths.nameHistory,
			ComponentIn: lazy(() => import('Components/KycAdmin/KycHistory/NameHistory/NameHistory')),
		},
		{
			path: Paths.bankHistory,
			ComponentIn: lazy(() => import('Components/KycAdmin/KycHistory/BankHistory/BankHistory')),
		},
		{
			path: Paths.emailHistory,
			ComponentIn: lazy(() => import('Components/KycAdmin/KycHistory/EmailHistory/EmailHistory')),
		},
		// {
		//   path: Paths.panHistory,
		//   ComponentIn: lazy(() => import("Components/KycAdmin/KycHistory/PanHistory/PanHistory"))
		// },
		{
			path: Paths.addressHistory,
			ComponentIn: lazy(() => import('Components/KycAdmin/KycHistory/AddressHistory/AddressHistory')),
		},
		{
			path: Paths.terminationHistory,
			ComponentIn: lazy(() => import('Components/KycAdmin/KycHistory/TerminationHistory/TerminationHistory')),
		},
		{
			path: Paths.notOkHistory,
			ComponentIn: lazy(() => import('Components/KycAdmin/KycHistory/NotOkHistory/NotOkHistory')),
		},
		{
			path: Paths.yourGroup,
			ComponentIn: lazy(() => import('Components/Admin/YourGroup/yourGroupModule')),
		},
		{
			path: Paths.productPurchase,
			ComponentIn: lazy(() => import('Components/Admin/ProductPurchase/ProductPurchaseModule')),
		},
		{
			path: Paths.lastMonthPVDatewise,
			ComponentIn: lazy(() => import('Components/Admin/LastMonthPVDatewise/LastMonthPVDatewiseModule')),
		},
		{
			path: Paths.purchaseVolumeCalculator,
			ComponentIn: lazy(() => import('Components/Admin/PurchaseVolumeCalculator')),
		},
		// {
		//   path: Paths.taxInvoice,
		//   ComponentIn: lazy(() => import("Components/Admin/TaxInvoice"))
		// },
		{
			path: Paths.gstInvoice,
			ComponentIn: lazy(() => import('Components/Admin/GstInvoice')),
		},
		{
			path: Paths.productPurchaseMonthly,
			ComponentIn: lazy(() => import('Components/Admin/ProductPurchaseMonthly/ProductPurchaseMonthlyModule')),
		},

		// Product Category Report
		{
			path: Paths.productCategoryReport,
			ComponentIn: lazy(() => import('Components/Admin/ProductCategoryReport/ProductCategoryReport')),
		},
		// Cart Products Report
		{
			path: Paths.cartProductsReport,
			ComponentIn: lazy(() => import('Components/Admin/CartProductsReport/CartProductsReport')),
		},
		// Report View Logs
		{
			path: Paths.reportViewLogs,
			ComponentIn: lazy(() => import('Components/Admin/ReportViewLogs/ReportViewLogs')),
		},
		{
			path: Paths.userActivityLogs,
			ComponentIn: lazy(() => import('Components/Admin/UserActivityLogs/UserActivityLogs')),
		},
		{
			path: Paths.internalReportViewLogs,
			ComponentIn: lazy(() => import('Components/Admin/InternalReportViewLogs/InternalReportViewLogs')),
		},
		// STO Loading History — admin view of the inventory-management Flutter app
		{
			path: Paths.stoLoadingHistory,
			ComponentIn: lazy(() => import('Components/Admin/StoLoadingHistory/StoLoadingHistory')),
		},
		// STO Allowed Products — allow-list of SAP codes eligible for the mobile app
		{
			path: Paths.stoAllowedProducts,
			ComponentIn: lazy(() => import('Components/Admin/StoAllowedProducts/StoAllowedProducts')),
		},
		// Monthly Statement
		{
			path: Paths.monthlyStatement,
			ComponentIn: lazy(() => import('Components/Admin/MonthlyStatement/MonthlyStatement')),
		},
		// AB Growth Report
		{
			path: Paths.abGrowthReport,
			ComponentIn: lazy(() => import('Components/Admin/ABGrowthReport/ABGrowthReport')),
		},
		// ulp Program Report
		{
			path: Paths.ulpProgramReport,
			ComponentIn: lazy(() => import('Components/Admin/ulpProgramReport/ULPProgramReport')),
		},
		// Zonal Program Report
		{
			path: Paths.zonalProgramReport,
			ComponentIn: lazy(() => import('Components/Admin/ZonalProgramReport/ZonalProgramReport')),
		},
		{
			path: Paths.technicalGroupStructure,
			ComponentIn: lazy(
				() => import('Components/Admin/TechnicalGroupStructureReport/TechnicalGroupStructureReportModule')
			),
		},
		// Product Price List
		{
			path: Paths.productPriceList,
			ComponentIn: lazy(() => import('Components/Admin/ProductPriceList/ProductPriceList')),
		},

		// Zonal - Sales User
		{
			path: Paths.zonalSalesUser,
			ComponentIn: lazy(() => import('Components/Admin/Zonal/SalesUser/SalesUserList')),
		},

		// Zonal - Observation Checklist
		{
			path: Paths.zonalObservation,
			ComponentIn: lazy(() => import('Components/Admin/Zonal/ObservationChecklist/ObservationChecklistManager')),
		},

		// Store Feedback
		{
			path: Paths.storeFeedback,
			ComponentIn: lazy(() => import('Components/Admin/StoreFeedback/StoreFeedback')),
		},

		// Schedule Management
		{
			path: Paths.scheduleManagement,
			ComponentIn: lazy(() => import('Components/Admin/ScheduleManagement/CreateMaintenanceSchedule')),
		},
		// Post Purchase Feedback
		{
			path: Paths.postPurchaseFeedback,
			ComponentIn: lazy(() => import('Components/Admin/PostPurchaseFeedback/PostPurchaseFeedback')),
		},

		// New Joiner Feedback
		{
			path: Paths.newJoinerFeedback,
			ComponentIn: lazy(() => import('Components/Admin/NewJoinerFeedback/NewJoinerFeedback')),
		},
		// Hygiene Campaigns Report
		{
			path: Paths.HygieneCampaigns,
			ComponentIn: lazy(
				() => import('Components/Admin/CallCenterReports/HygieneCampaigns/HygieneCampaignsIndex')
			),
		},

		// Change Password
		{
			path: Paths.changePassword,
			ComponentIn: lazy(() => import('Components/Authentication/ChangePassword')),
		},

		// Mashal Report
		{
			path: Paths.mashalReport,
			ComponentIn: lazy(() => import('Components/Admin/MashalReport/MashalReportModule')),
		},

		// Gooddot Rasoi
		{
			path: Paths.manageGooddotRasoiBatch,
			ComponentIn: lazy(() => import('Components/Admin/GooddotRasoi/GooddotRasoiModule')),
		},
		{
			path: Paths.manageGooddotRasoiApplications,
			ComponentIn: lazy(() => import('Components/Admin/GooddotRasoi/GooddotRasoiApplicationsList')),
		},
		{
			path: Paths.gooddotRasoiReport,
			ComponentIn: lazy(() => import('Components/Admin/GooddotRasoi/GooddotRasoiReport')),
		},
		{
			path: Paths.gooddotRasoiAdd,
			ComponentIn: lazy(() => import('Components/Admin/GooddotRasoi/GooddotRasoiAddEdit')),
		},
		{
			path: Paths.gooddotRasoiEdit + '/:id',
			ComponentIn: lazy(() => import('Components/Admin/GooddotRasoi/GooddotRasoiAddEdit')),
		},
		{
			path: Paths.gooddotRasoiView + '/:id',
			ComponentIn: lazy(() => import('Components/Admin/GooddotRasoi/GooddotRasoiView')),
		},

		// Sehat ke Sitaare
		{
			path: Paths.sehatKeSitaare,
			ComponentIn: lazy(() => import('Components/Admin/SehatKeSitaare/SehatKeSitaareList')),
		},
		{
			path: `${Paths.sehatKeSitaareReport}/:reportId/:day/`,
			ComponentIn: lazy(() => import('Components/Admin/SehatKeSitaare/SehatKeSitaareReportView')),
		},

		// Sehat Mitra
		{
			path: Paths.sehatMitra,
			ComponentIn: lazy(() => import('Components/Admin/SehatMitra/SehatMitraList')),
		},
		{
			path: `${Paths.sehatMitraReport}/:reportId/:day/`,
			ComponentIn: lazy(() => import('Components/Admin/SehatMitra/SehatMitraReportView')),
		},
		{
			path: Paths.manageSehatMitraCourseReport,
			ComponentIn: lazy(() => import('Components/Admin/SehatMitra/CourseRegistrationReport/ManageCourseReport')),
		},
		{
			path: Paths.manageSehatMitraCourseBatch,
			ComponentIn: lazy(() => import('Components/Admin/SehatMitra/CourseBatch/ManageCourseBatch')),
		},
		{
			path: Paths.manageSehatMitraCourseBatchAdd,
			ComponentIn: lazy(() => import('Components/Admin/SehatMitra/CourseBatch/AddEditCourseBatch')),
		},
		{
			path: `${Paths.manageSehatMitraCourseBatchEdit}/:id`,
			ComponentIn: lazy(() => import('Components/Admin/SehatMitra/CourseBatch/AddEditCourseBatch')),
		},

		// Disease Management
		{
			path: Paths.diseaseManagement,
			ComponentIn: lazy(() => import('Components/Admin/DiseaseMgmt/DiseaseManagement')),
		},

		// Post / Courier receipt module
		{
			path: Paths.postList,
			ComponentIn: lazy(() => import('Components/Admin/Post/PostList')),
		},
		{
			path: Paths.postAdd,
			ComponentIn: lazy(() => import('Components/Admin/Post/PostAddEdit')),
		},
		{
			// Same form, outward direction — labels flip, storage is one register
			path: Paths.postAddOutward,
			ComponentIn: lazy(() => import('Components/Admin/Post/PostAddEdit')),
		},
		{
			path: `${Paths.postEdit}/:id`,
			ComponentIn: lazy(() => import('Components/Admin/Post/PostAddEdit')),
		},
		{
			path: `${Paths.postView}/:id`,
			ComponentIn: lazy(() => import('Components/Admin/Post/PostView')),
		},
		{
			path: Paths.postReport,
			ComponentIn: lazy(() => import('Components/Admin/Post/PostReport')),
		},
		{
			path: Paths.postDashboard,
			ComponentIn: lazy(() => import('Components/Admin/Post/PostDashboard')),
		},
		{
			path: Paths.postCouriers,
			ComponentIn: lazy(() => import('Components/Admin/Post/CourierList')),
		},

		// QR Generator — carton sticker printing
		{
			path: Paths.qrGenerator,
			ComponentIn: lazy(() => import('Components/Admin/QRGenerator/GenerateQR')),
		},
		{
			path: Paths.qrGeneratorHistory,
			ComponentIn: lazy(() => import('Components/Admin/QRGenerator/QRHistory')),
		},

		// Consistency Calculator — 6-month PV → wallet credit
		{
			path: Paths.consistencyCalculator,
			ComponentIn: lazy(() => import('Components/Admin/ConsistencyCalculator/ConsistencyCalculator')),
		},
		{
			path: Paths.consistencyUpload,
			ComponentIn: lazy(() => import('Components/Admin/ConsistencyCalculator/UploadBatch')),
		},
		{
			path: Paths.consistencyPeriods,
			ComponentIn: lazy(() => import('Components/Admin/ConsistencyCalculator/PeriodsList')),
		},
		{
			path: `${Paths.consistencyPeriods}/:periodId`,
			ComponentIn: lazy(() => import('Components/Admin/ConsistencyCalculator/PeriodView')),
		},
		// Cash Bonus — 6-month sustained PV → flat reward
		{
			path: Paths.cashBonusCalculator,
			ComponentIn: lazy(() => import('Components/Admin/CashBonus/CashBonus')),
		},
		{
			path: Paths.cashBonusUpload,
			ComponentIn: lazy(() => import('Components/Admin/CashBonus/UploadBatch')),
		},
		{
			path: Paths.cashBonusPeriods,
			ComponentIn: lazy(() => import('Components/Admin/CashBonus/PeriodsList')),
		},
		{
			path: `${Paths.cashBonusPeriods}/:periodId`,
			ComponentIn: lazy(() => import('Components/Admin/CashBonus/PeriodView')),
		},
		// Sewa Diwas Routes
		{
			path: Paths.sewaDiwasPreEvents,
			ComponentIn: lazy(() => import('Components/Admin/SewaDiwas/PreEventsList')),
		},
		{
			path: Paths.sewaDiwasPostEvents,
			ComponentIn: lazy(() => import('Components/Admin/SewaDiwas/PostEventsList')),
		},
		{
			path: Paths.sewaDiwasDigitalMaterials,
			ComponentIn: lazy(() => import('Components/Admin/SewaDiwas/DigitalMaterials')),
		},
		{
			path: Paths.sewaDiwasReports,
			ComponentIn: lazy(() => import('Components/Admin/SewaDiwas/ReportsExports')),
		},
		{
			path: Paths.sewaDiwasRatings,
			ComponentIn: lazy(() => import('Components/Admin/SewaDiwas/RatingsMgmt')),
		},

		// ─── Genie: Master Company Targets ───────────────────────────────────────
		{
			path: Paths.genieCompanyTarget,
			ComponentIn: lazy(() => import('Components/Admin/Genie/MasterCompanyTargets/MasterCompanyTargetList')),
		},
		{
			path: Paths.genieCompanyTargetAdd,
			ComponentIn: lazy(() => import('Components/Admin/Genie/MasterCompanyTargets/MasterCompanyTargetAdd')),
		},
		{
			path: `${Paths.genieCompanyTargetEdit}/:id`,
			ComponentIn: lazy(() => import('Components/Admin/Genie/MasterCompanyTargets/MasterCompanyTargetEdit')),
		},

		// ─── Genie: Master Activity ──────────────────────────────────────
		{
			path: Paths.genieActivity,
			ComponentIn: lazy(() => import('Components/Admin/Genie/MasterActivity/MasterActivityList')),
		},
		{
			path: Paths.genieActivityAdd,
			ComponentIn: lazy(() => import('Components/Admin/Genie/MasterActivity/MasterActivityAdd')),
		},
		{
			path: `${Paths.genieActivityEdit}`,
			ComponentIn: lazy(() => import('Components/Admin/Genie/MasterActivity/MasterActivityEdit')),
		},

		// ─── Genie: Master Activity Targets ──────────────────────────────────────
		{
			path: Paths.genieActivityTarget,
			ComponentIn: lazy(() => import('Components/Admin/Genie/MasterActivityTargets/MasterActivityTargetList')),
		},
		{
			path: Paths.genieActivityTargetAdd,
			ComponentIn: lazy(() => import('Components/Admin/Genie/MasterActivityTargets/MasterActivityTargetAdd')),
		},

		// ─── Genie: Master Skill Development Targets ─────────────────────────────
		{
			path: Paths.genieSkillDevelopmentTarget,
			ComponentIn: lazy(
				() => import('Components/Admin/Genie/MasterSkillDevelopmentTargets/MasterSkillDevelopmentTargetList')
			),
		},
		{
			path: Paths.genieSkillDevelopmentTargetAdd,
			ComponentIn: lazy(
				() => import('Components/Admin/Genie/MasterSkillDevelopmentTargets/MasterSkillDevelopmentTargetAdd')
			),
		},

		// ─── Genie: Master GMV ───────────────────────────────────────────────────
		{
			path: Paths.genieGmv,
			ComponentIn: lazy(() => import('Components/Admin/Genie/MasterGMV/MasterGMVList')),
		},
		{
			path: Paths.genieGmvAdd,
			ComponentIn: lazy(() => import('Components/Admin/Genie/MasterGMV/MasterGMVAdd')),
		},
		{
			path: `${Paths.genieGmvEdit}/:id`,
			ComponentIn: lazy(() => import('Components/Admin/Genie/MasterGMV/MasterGMVEdit')),
		},

		// ─── Genie: Target Report ─────────────────────────────────────────────
		{
			path: Paths.genieTargetReport,
			ComponentIn: lazy(() => import('Components/Admin/Genie/TargetReport/TargetReportList')),
		},

		// ─── Genie: Achievement Report ────────────────────────────────────────
		{
			path: Paths.genieAchievementReport,
			ComponentIn: lazy(() => import('Components/Admin/Genie/AchievementReport/AchievementReportList')),
		},

		// ─── Genie: Review and Approval ────────────────────────────────────────
		{
			path: Paths.genieReviewAndApproval,
			ComponentIn: lazy(() => import('Components/Admin/Genie/ReviewAndApproval/ReviewAndApprovalList')),
		},

		// ─── Genie: Pillar Mapping ─────────────────────────────────────────────
		{
			path: Paths.geniePillarMapping,
			ComponentIn: lazy(() => import('Components/Admin/Genie/MasterPillarMapping/MasterPillarMappingList')),
		},
		{
			path: Paths.geniePillarMappingAdd,
			ComponentIn: lazy(() => import('Components/Admin/Genie/MasterPillarMapping/MasterPillarMappingAdd')),
		},
		// ─── Report Execution Performance Analytics ──────────────────────────────────
		{
			path: Paths.reportAnalytics,
			ComponentIn: lazy(() => import('Components/Admin/ReportAnalytics/ReportAnalyticsDashboard')),
		},

		// ─── Drive Management: Revenue Targets ───────────────────────────────────
		{
			path: Paths.driveRevenueTarget,
			ComponentIn: lazy(() => import('Components/Admin/DriveManagement/RevenueTargets/RevenueTargetList')),
		},
		{
			path: `${Paths.driveRevenueTarget}/add`,
			ComponentIn: lazy(() => import('Components/Admin/DriveManagement/RevenueTargets/RevenueTargetAdd')),
		},
		{
			path: `${Paths.driveRevenueTarget}/edit/:id`,
			ComponentIn: lazy(() => import('Components/Admin/DriveManagement/RevenueTargets/RevenueTargetEdit')),
		},

		// ─── Drive Management: Revenue Report ────────────────────────────────────
		{
			path: Paths.driveRevenueReport,
			ComponentIn: lazy(() => import('Components/Admin/DriveManagement/RevenueReport/RevenueReport')),
		},

		// ─── Drive Management: Reactivation Report ─────────────────────────────
		{
			path: Paths.driveReactivationReport,
			ComponentIn: lazy(() => import('Components/Admin/DriveManagement/ReactivationReport/ReactivationReport')),
		},

		//  ─── Drive Management: MIS Report ─────────────────────────────
		{
			path: Paths.driveMISReport,
			ComponentIn: lazy(() => import('Components/Admin/DriveManagement/MisReport/MisReport')),
		},

		// ─── Drive Management: Repurchaser Targets ─────────────────────────────
		{
			path: Paths.driveRepurchaserTargetList,
			ComponentIn: lazy(() => import('Components/Admin/DriveManagement/RepurchaserTarget/RepurchaserTargetList')),
		},

		{
			path: Paths.driveRepurchaserTargetAdd,
			ComponentIn: lazy(
				() => import('Components/Admin/DriveManagement/RepurchaserTarget/RepurchaserTargetAddAndEdit')
			),
		},

		{
			path: Paths.driveRepurchaserTargetEdit,
			ComponentIn: lazy(
				() => import('Components/Admin/DriveManagement/RepurchaserTarget/RepurchaserTargetAddAndEdit')
			),
		},

		// ─── Drive Management: Repurchaser Report ─────────────────────────────
		{
			path: Paths.driveRepurchaserReport,
			ComponentIn: lazy(() => import('Components/Admin/DriveManagement/RepurchaserReport/RepurchaserReport')),
		},

		// ─── Product availability tracking ─────────────────────────────
		{
			path: Paths.productAvailabilityTrackingList,
			ComponentIn: lazy(
				() => import('Components/Admin/ProductAvailabilityTracking/ProductAvailabilityTrackingList')
			),
		},
		{
			path: Paths.productAvailabilityTrackingAdd,
			ComponentIn: lazy(
				() => import('Components/Admin/ProductAvailabilityTracking/ProductAvailabilityTrackingAddAndEdit')
			),
		},
		{
			path: Paths.productAvailabilityTrackingEdit,
			ComponentIn: lazy(
				() => import('Components/Admin/ProductAvailabilityTracking/ProductAvailabilityTrackingAddAndEdit')
			),
		},

		// ─── south ceremony events ─────────────────────────────
		{
			path: Paths.southCeremonyEventLeaders,
			ComponentIn: lazy(() => import('Components/Admin/southCeremonyEvent/leadersManager/LeadersManager')),
		},
		{
			path: Paths.southCeremonyEventReportAssignments,
			ComponentIn: lazy(() => import('Components/Admin/southCeremonyEvent/reportAssignments/ReportAssignments')),
		},

		// ─── Authenza Club ─────────────────────────────────────────────
		{
			path: Paths.authenzaClubAnalytics,
			ComponentIn: lazy(() => import('Components/Admin/AuthenzaaPreLaunch/AuthenzaaClubPreLaunchAnalytics')),
		},
		{
			path: Paths.authenzaClubNotifyMe,
			ComponentIn: lazy(() => import('Components/Admin/AuthenzaaPreLaunch/AuthenzaaClubPreLaunchNotifyMe')),
		},
	],
};

export const publicRoutes = [
	{
		path: Paths.nf,
		ComponentIn: lazy(() => import('Components/404/index')),
	},
	{
		path: Paths.base,
		ComponentIn: lazy(() => import('Components/Authentication/login')),
	},
	// {
	//   path: Paths.admin,
	//   ComponentIn: lazy(() => import("Components/Authentication/login"))
	// },
	{
		path: Paths.forgot + '/:type',
		ComponentIn: lazy(() => import('Components/Authentication/forgotPassword')),
	},
];
